<template>
    <div class="flex snap-x snap-proximity overflow-x-auto overscroll-y-none">
        <!-- mx-auto en un hijo flex-none (no justify-center en el contenedor con
             scroll): con justify-center, cuando las tarjetas desbordan, la
             primera queda recortada a la izquierda y no se puede alcanzar. -->
        <div class="mx-auto flex flex-none">
            <component
                :is="item.href ? 'a' : 'div'"
                v-for="item in items"
                :key="item.key"
                v-bind="linkAttrs(item)"
                :aria-label="item.title"
                class="relative mx-4 my-4 flex flex-shrink-0 snap-center items-center justify-center overflow-hidden rounded-3xl bg-stack-text shadow-lg no-underline"
                :class="isDesktop ? 'h-56 w-72' : 'h-40 w-52'"
                @click="onClick"
            >
                <img
                    v-if="item.imageUrl"
                    :src="item.imageUrl"
                    :alt="item.imageAlt"
                    class="h-full w-full object-cover"
                />
                <div v-else class="absolute inset-0">
                    <slot name="placeholder" :item="item"></slot>
                </div>
            </component>
        </div>
    </div>
</template>

<script>
export default {
    name: "SliderV4",
    props: {
        items: { type: Array, required: true },
        previewOnly: { type: Boolean, default: false },
        isDesktop: { type: Boolean, default: true }
    },
    methods: {
        linkAttrs(item) {
            return item.href
                ? { href: item.href, target: item.target, rel: item.rel }
                : {};
        },
        onClick(event) {
            if (this.previewOnly) event.preventDefault();
        }
    }
};
</script>
